export enum FeatureControlActionType {
  LoadFeatures = '[Feature Control] Load Features',
  LoadFeaturesCompleted = '[Feature Control] Load Features Completed',
  LoadFeaturesFailed = '[Feature Control] Load Features Failed',
}
